// import React, { useState } from "react";
// import { BASE_URL } from "../../../constant/api";
// import { Link } from "react-router-dom";

// const CircleCard = ({ data, title, bg, id, icon }) => {
//   const [expanded, setExpanded] = useState(false);

//   const toggleView = () => {
//     setExpanded(!expanded);
//   };

//   return (
//     <>
//       <div className="flex items-center justify-between px-5">
//         <div className="flex flex-row items-center justify-between space-x-4">
//           <h2 className="text-2xl font-semibold md:text-3xl">{title}</h2>
//           {icon && (
//             <Link
//               to="/"
//               className="cursor-pointer text-4xl text-green-500 hover:text-blue-500"
//             >
//               {icon}
//             </Link>
//           )}
//         </div>

//         <p
//           onClick={toggleView}
//           className="cursor-pointer text-xl text-brand-text-light transition duration-500 ease-in-out hover:text-brand-primary"
//         >
//           {expanded ? "Collapse" : "View All"}
//         </p>
//       </div>
//       <div
//         // className={`p-4 transition-all duration-500 ease-in-out ${expanded ? 'grid grid-cols-4 md:grid-cols-6 lg:grid-cols-10 gap-6' : 'flex overflow-x-auto space-x-6'}`}
//         className={`p-4 transition-all duration-500 ease-in-out ${
//           expanded
//             ? "grid grid-cols-4 gap-6 md:grid-cols-6 lg:grid-cols-10"
//             : "space-x- flex gap-4 overflow-x-auto"
//         }`}
//       >
//         {data.map((d) => (
//           <div
//             key={d.id} // Ensure category.id is unique
//             // className="flex flex-col   items-center justify-center"
//             className="flex w-28 flex-col items-center justify-center"
//           >
//             <Link to={`/category/${d.id}?sub=all`}>
//               <div
//                 className={`flex h-20 w-20 md:h-24 md:w-24 items-center justify-center overflow-hidden rounded-full border-[3px] border-green-500 ${bg} ${
//                   id === String(d.id)
//                     ? "scale-110 border-4 border-green-500"
//                     : ""
//                 }`}
//               >
//                 <img
//                   src={
//                     d.image
//                       ? d.image.startsWith(BASE_URL)
//                         ? d.image
//                         : `${BASE_URL}${d.image}`
//                       : "https://via.placeholder.com/100"
//                   }
//                   alt={d.name || d.brandname || "Image"}
//                   className="h-full w-full rounded-full object-cover p-1"
//                 />
//               </div>
//             </Link>
//             <span
//               // className={`text-center line-clamp-2 mt-2 text-xs w-24 overflow-hidden text-ellipsis ${id === String(d.id) ? "text-green-500 font-semibold" : ""
//               className={`mt-2 line-clamp-1 overflow-hidden text-ellipsis text-center text-xs hover:line-clamp-none ${
//                 id === String(d.id) ? "font-semibold text-green-500" : ""
//               }`}
//             >
//               {d.name || d.brandname || "Unnamed"}{" "}
//               {/* Fallback to 'Unnamed' if both are unavailable */}
//             </span>
//           </div>
//         ))}
//       </div>
//     </>
//   );
// };

// export default CircleCard;

import React, { useState, useRef, useEffect } from "react";
import { BASE_URL } from "../../../constant/api";
import { Link } from "react-router-dom";

const CircleCard = ({ data, title, bg, id, icon }) => {
  const [expanded, setExpanded] = useState(false);
  const [showViewAll, setShowViewAll] = useState(false);
  const containerRef = useRef(null);

  const toggleView = () => {
    setExpanded(!expanded);
  };

  useEffect(() => {
    const checkOverflow = () => {
      if (containerRef.current) {
        const container = containerRef.current;
        // Check if the container is overflowing horizontally
        const isOverflowing = container.scrollWidth > container.clientWidth;
        setShowViewAll(isOverflowing);
      }
    };

    checkOverflow();
    window.addEventListener('resize', checkOverflow);

    return () => {
      window.removeEventListener('resize', checkOverflow);
    };
  }, [data]); // Re-check when data changes

  return (
    <>
      <div className="flex items-center justify-between px-5">
        <div className="flex flex-row items-center justify-between space-x-4">
          <h2 className="text-2xl font-semibold md:text-3xl">{title}</h2>
          {icon && (
            <Link
              to="/"
              className="cursor-pointer text-4xl text-green-500 hover:text-green-400 "
            >
              {icon}
            </Link>
          )}
        </div>

        {showViewAll && (
          <p
            onClick={toggleView}
            className="cursor-pointer text-xl text-brand-text-light transition duration-500 ease-in-out hover:text-brand-primary"
          >
            {expanded ? "Collapse" : "View All"}
          </p>
        )}
      </div>
      <div
        ref={containerRef}
        className={`p-4 transition-all duration-500 ease-in-out ${
          expanded
            ? "grid grid-cols-4 gap-6 md:grid-cols-6 lg:grid-cols-10"
            : "flex gap-4 overflow-x-auto"
        }`}
      >
        {data.map((d) => (
          <div
            key={d.id}
            className="flex w-28 flex-col items-center justify-center"
          >
            <Link to={`/category/${d.id}?sub=all`}>
              <div
                className={`flex h-20 w-20 items-center hover:scale-110 transition-transform ease-in-out duration-300 justify-center overflow-hidden rounded-full border-[3px] border-gray-400 hover:border-green-500 md:h-24 md:w-24 ${bg} ${
                  id === String(d.id)
                    ? "scale-110 border-4 border-green-500"
                    : ""
                }`}
              >
                <img
                  src={
                    d.image
                      ? d.image.startsWith(BASE_URL)
                        ? d.image
                        : `${BASE_URL}${d.image}`
                      : "https://via.placeholder.com/100"
                  }
                  alt={d.name || d.brandname || "Image"}
                  className="h-full w-full rounded-full object-cover p-1"
                />
              </div>
            </Link>
            <span
              className={`mt-2 line-clamp-1 overflow-hidden text-ellipsis text-center text-xs  ${
                id === String(d.id) ? "font-semibold text-green-500" : ""
              }`}
            >
              {d.name || d.brandname || "Unnamed"}
            </span>
          </div>
        ))}
      </div>
    </>
  );
};

export default CircleCard;
